import { ShieldCheck } from "lucide-react";
import { useLocation as useRouterLocation } from "react-router-dom";

export const Guarantee = () => {
  const { pathname } = useRouterLocation();
  const isEs = pathname.startsWith('/es');
  const isRu = pathname.startsWith('/ru');
  const isZh = pathname.startsWith('/zh');

  const title = isZh ? "我们的200%铁腕保证" : isRu ? "Наша 200% железная гарантия" : isEs ? "Nuestra Garantía del 200%" : "Our 200% Ironclad Guarantee";
  
  const p1_1 = isZh ? "我们对清洁质量充满信心，因此提供" : isRu ? "Мы настолько уверены в качестве нашей уборки, что предлагаем " : isEs ? "Estamos tan seguros de la calidad de nuestra limpieza que ofrecemos una " : "We're so confident in the quality of our cleaning that we offer a ";
  const p1_strong = isZh ? "200%铁腕保证" : isRu ? "200% железную гарантию" : isEs ? "Garantía del 200%" : "200% Ironclad Guarantee";
  
  const p2 = isZh ? "如果您对清洁不完全满意，只需在48小时内通知我们。我们将免费返回并重新清洁您不满意的区域。" : isRu ? "Если вы не полностью удовлетворены уборкой, просто сообщите нам об этом в течение 48 часов. Мы вернемся и бесплатно переделаем те участки, которыми вы недовольны." : isEs ? "Si no estás completamente satisfecho con tu limpieza, simplemente avísanos dentro de las 48 horas. Regresaremos y volveremos a limpiar las áreas con las que no estés contento completamente gratis." : "If you're not completely satisfied with your clean, simply let us know within 48 hours. We will return and re-clean the areas you're unhappy with completely free of charge.";
  
  const p3_1 = isZh ? "如果在第二次清洁后您仍然不满意，我们将退还您的款项。" : isRu ? "Если после повторной уборки вы все еще недовольны, мы вернем вам деньги. " : isEs ? "Si aún no estás contento después de la segunda limpieza, te devolveremos tu dinero. " : "If you are still not happy after the re-clean, we will refund your money. ";
  const p3_strong = isZh ? "不问理由，毫无怨言。" : isRu ? "Без лишних вопросов и обид." : isEs ? "Sin preguntas, sin problemas." : "No questions asked, no hard feelings.";

  return (
    <section className="py-24 bg-primary text-primary-foreground relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl" />
      
      <div className="container relative z-10 max-w-4xl text-center">
        <div className="inline-flex items-center justify-center p-4 bg-white/10 rounded-full mb-8 shadow-xl">
          <ShieldCheck className="h-12 w-12 text-white" />
        </div>
        <h2 className="text-3xl md:text-5xl font-bold mb-8">{title}</h2>
        <div className="space-y-6 text-lg md:text-xl opacity-90 max-w-3xl mx-auto leading-relaxed">
          <p>
            {p1_1}<strong>{p1_strong}</strong>.
          </p>
          <p>
            {p2}
          </p>
          <p>
            {p3_1}<strong>{p3_strong}</strong>
          </p>
        </div>
      </div>
    </section>
  );
};
